import { DELETE_DMX_CONTROLLER, DELETE_DMX_CONTROLLER_SUCCESSFUL, DELETE_DMX_CONTROLLER_FAILED } from './actionTypes';

const initialState = {
  deleteDmxControllerError: null,
  messageDmxController: null,
  loadingDeleteDmxController: false,
};

const deleteController = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_DMX_CONTROLLER:
      state = { ...state, loadingDeleteDmxController: true, deleteDmxControllerError: null };
      break;
    case DELETE_DMX_CONTROLLER_SUCCESSFUL:
      state = { ...state, loadingDeleteDmxController: false, messageDmxController: action.payload, deleteDmxControllerError: null };
      break;
    case DELETE_DMX_CONTROLLER_FAILED:
      state = { ...state, messageDmxController: null, loadingDeleteDmxController: false, deleteDmxControllerError: action.payload };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default deleteController;
